export enum SSOType {
  OAUTH = "OAUTH",
}

export enum SSOProvider {
  ENTRA_ID = "ENTRA_ID",
}

export function getSSOTypes(): { text: string; value: SSOType }[] {
  return [
    { text: "OAuth", value: SSOType.OAUTH },
  ];
}

export function getSSOProviders(): { text: string; value: SSOProvider }[] {
  return [{ text: "Microsoft Entra ID", value: SSOProvider.ENTRA_ID }];
}

export interface EntraIdOAuthConfig {
  clientId: string;
  clientSecret: string;
  authUrl: string;
  tokenUrl: string;
  userInfoUrl: string;
}

export interface SSOConfig {
  id: string;
  active: boolean;
  domain: string;
  type: SSOType;
  provider: SSOProvider;
  entraIdOAuthConfig?: EntraIdOAuthConfig;
}
